import { Container } from "react-bootstrap";
import MainNavbar from "../../components/reuse/MainNavbar";
import PersonDropdown from "../../components/reuse/PersonDropdown";
import ArchiveAuditsBlock from "../../components/personal/ArchiveAudits/ArchiveAuditsBlock";
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure";

const ArchiveAuditPage = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Архивные аудиты"}>
            <ArchiveAuditsBlock/>
        </TypicalPageStructure>
        </>
    )
}

export default ArchiveAuditPage;